import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DirectiveModule } from './directives/directive.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Constant } from '../environments/constants';

import { LayoutService } from './services/util/layout.service';

import {MsalModule,MsalInterceptor,MSAL_CONFIG, MSAL_CONFIG_ANGULAR, MsalService, MsalAngularConfiguration} from '@azure/msal-angular';
import { ApplicationInsightsModule, AppInsightsService } from '@markpieszak/ng-application-insights';
import { Configuration } from 'msal';


import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import {MatRadioModule} from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ContextDebugModule } from './context-components/context-debug/context-debug.module';



export const protectedResourceMap: [string, string[]][] = [
  [Constant.config.apiBaseUrl, Constant.config.scopes],
  [Constant.config.cosmosSearchAPI, Constant.config.scopes],  
  [Constant.config.ipProfileAPI, Constant.config.scopes],
  [Constant.config.goalsProfileAPI, Constant.config.scopes],
  [Constant.config.invAPI, Constant.config.scopes],
  [Constant.config.pmAPI, Constant.config.scopes]
];


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

function MSALConfigFactory(): Configuration {
  return {
    auth: {
      clientId: Constant.config.clientId,
      authority: Constant.config.autority,
      validateAuthority: true,
      redirectUri: window.location.origin + "/signin-oidc",
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system:{
      loadFrameTimeout:35000,
    }
  };
}

function MSALAngularConfigFactory(): MsalAngularConfiguration {
  return {
    popUp: !isIE,
    consentScopes: Constant.config.scopes,
    unprotectedResources: ["https://www.microsoft.com/en-us/"],
    protectedResourceMap,
    extraQueryParameters: {}
  };
}



@NgModule({
  declarations: [
    AppComponent,    
  ],
  imports: [
    AppRoutingModule,    
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ContextDebugModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,    
    FormsModule,
    MsalModule,
    DirectiveModule,
    ApplicationInsightsModule.forRoot({
      instrumentationKeySetLater: true // <--
    }) 
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_CONFIG,
      useFactory: MSALConfigFactory
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: MSALAngularConfigFactory
    },
    MsalService,    
    AppInsightsService,
    LayoutService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
